import React from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { TOS_VERSION } from '../../constants/termsOfService'
import { TosAcceptanceOverlay } from './TosAcceptanceOverlay'

/**
 * 認証済みユーザーが利用規約に同意しているかをチェックするガード。
 * 未同意 or 旧バージョンの場合は同意オーバーレイを全画面に出す。
 * ProtectedRoute の内側に置くこと（user が必ず存在する前提）
 */
export const TosGuard: React.FC = () => {
  const { user, checkSession } = useAuth()

  // user が無いケースは ProtectedRoute が先に弾くため通常通らない。
  // 念のため通った場合は Outlet を返す（ProtectedRoute 側のローディングに任せる）
  if (!user) return <Outlet />

  const needsAccept = !user.tosAcceptedAt || user.tosVersion !== TOS_VERSION

  if (!needsAccept) return <Outlet />

  return (
    <TosAcceptanceOverlay
      onAccepted={async () => {
        // user 情報を再取得 → tosAcceptedAt が埋まり、再レンダで Outlet になる
        // 失敗時はオーバーレイ側でリロードフォールバックする
        await checkSession()
      }}
    />
  )
}
